export const baseURL = "https://karirai-dev.s3.ap-southeast-3.amazonaws.com/images/";
export const baseUrl = "https://karirai-dev.s3.ap-southeast-3.amazonaws.com/";
export const logo = `${baseUrl}logo-karirai-notext-200.png`